import DataroomTab from "../../../components/dataRoom/DataRoomTab";

export default function DataRoomTab({ project }) {
  return (
    <>
      <DataroomTab id={project?._id} path={"project"} />
    </>
  );
}
